/** `TraitCategory.MAGIC` on the server: the skills magical rolls add as terms. */
export const MAGIC_SKILL_CATEGORY = 'magic';
